import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Menu, MenuItem } from "@material-ui/core";
import { FormControl, InputLabel } from "@material-ui/core";
import Select from "react-select"
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import MarketerBaseState from "./MarketerBase/MarketerBaseState"

import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import TableSortLabel from "@material-ui/core/TableSortLabel"


import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Calendar from "react-modern-calendar-datepicker";

import LinearProgress from "@material-ui/core/LinearProgress"

import RequestSmsReceiver from "./RequestSmsReceiver";
import FloatingLabelInput from "./FloatingLabelInput";
import FilterPanel from "./FilterPanel";
import Grow from "@material-ui/core/Grow";
import CustomSelect from "./common/CustomSelect";
import MarketerBaseService from "./MarketerBase/MarketerBaseService"; // مسیر بسته به پروژه‌ات تنظیم کن

const styles = (theme) => ({

    customDatePickerWrapper: {
        display: "block !important",
        width: "100% !important",
        position: "relative",
        zIndex: 100,
    },


    paperrtl: {
        marginTop: theme.spacing(0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    paper: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },
    root: {
        width: "100%",
        margin: "15px",
        padding: "8px",
        direction: "rtl",
    },
    container: {
        maxHeight: 400,
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    progress: {
        width: '100%',
        height: 10, // ارتفاع نوار درصد
    },
    progressContainer: {
        width: '100px', // عرض نوار درصد
    },
    errorBorder: {
        '& .react-select__control': {
            border: '1px solid red !important',
            borderRadius: 4,
        },
    },


})
const Text = (props) => {
    return (
        <Container>
            <div className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
            </div>
        </Container>
    );
};

class MyMarketerRequests extends Component {
    cookies = new Cookies()
    temp333
    constructor(props) {
        super(props)
        this.state = { ...MarketerBaseState };

    }
    handleTherapyInsurer = (selectedTherapyInsurer) => {
        this.setState({ selectedTherapyInsurer: selectedTherapyInsurer })
    }
    handleChangethirdpartyInsurancePrice = (event) => {
        this.setState({ thirdpartyInsurancePrice: event })
    }
    handlethirdpartyAddress = (event) => {
        this.setState({ thirdpartyAddress: event.target.value });
    }
    handlethirdpartyShippingAddress = (event) => {
        this.setState({ thirdpartyShippingAddress: event.target.value });
    }
    handlebodycarShippingAddress = (event) => {
        this.setState({ bodycarShippingAddress: event.target.value });
    }
    handlebodycarAddress = (event) => {
        this.setState({ bodycarAddress: event.target.value });
    }
    handleChangebodyCarInsurancePrice = (event) => {
        this.setState({ bodyCarInsurancePrice: event })
    }

    setSelectedDayStart = (event) => {
        this.setState({ selectedDayStart: event }, () => {
            // this.filterList();
        });
    };

    setselectedDateCallback = (event) => {
        this.setState({ selectedDateCallback: event });
    };
    setselectedThirdpartyDateOfSubmission = (event) => {
        this.setState({ selectedThirdpartyDateOfSubmission: event });
    };
    setselectedBodycarDateOfSubmission = (event) => {
        this.setState({ selectedBodycarDateOfSubmission: event });
    };
    setselectedBodycarDateOfVisit = (event) => {
        this.setState({ selectedBodycarDateOfVisit: event });
    };
    setSelectedDayEnd = (event) => {
        this.setState({ selectedDayEnd: event }, () => {
            // this.filterList();
        });
    };
    handleChangeDesc = (event) => {
        this.setState({ call_back_desc: event.target.value });
    };
    handleThirdpartyPostalCode = (event) => {
        this.setState({ thirdparty_postal_code: event.target.value });
    };
    handleBodycarPostalCode = (event) => {
        this.setState({ bodycar_postal_code: event.target.value });
    };

    handleCheckboxChange = (event) => {
        // تغییر وضعیت چک‌باکس
        this.setState({ isChecked: event.target.checked ? "true" : "false" });
    };
    gotoDetailRequest = (id,call_back_desc,call_back_status,call_back_date,selectedThirdpartyDateOfSubmission,
                         selectedBodycarDateOfSubmission,selectedBodycarDateOfVisit) => {

        this.setState({ call_back_desc: call_back_desc })
        this.setState({ isChecked: call_back_status })
        if (call_back_date) {
            const [year, month, day] = call_back_date.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedDateCallback: parsedDate });
        } else {
            this.setState({ selectedDateCallback: null });
        }


        if (selectedThirdpartyDateOfSubmission) {


            console.log("rrrrrrrrrrrrr",selectedThirdpartyDateOfSubmission)
            const [year, month, day] = selectedThirdpartyDateOfSubmission.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedThirdpartyDateOfSubmission: parsedDate });
        } else {
            this.setState({ selectedThirdpartyDateOfSubmission: null });
        }
        if (selectedBodycarDateOfSubmission) {


            const [year, month, day] = selectedBodycarDateOfSubmission.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedBodycarDateOfSubmission: parsedDate });
        } else {
            this.setState({ selectedBodycarDateOfSubmission: null });
        }
        if (selectedBodycarDateOfVisit) {


            const [year, month, day] = selectedBodycarDateOfVisit.split('/').map(Number);
            const parsedDate = { year, month, day };
            this.setState({ selectedBodycarDateOfVisit: parsedDate });
        } else {
            this.setState({ selectedBodycarDateOfVisit: null });
        }


        if (this.state.request_id === id) {
            this.setState({ request_id: null });
        }else {
            this.setState({ request_id: id })

        }
        this.setState({
            insuranceType: '',
        });



    }

    handleChangeCheakbox = (request_id) => {
        const { selectedDayEnd } = this.state;
        const { selectedDayStart } = this.state;
        const { call_back_desc } = this.state;
        const { isChecked } = this.state;
        const { selectedDateCallback } = this.state;

        const formatDate = ({ day, month, year }) => {
            const paddedMonth = month.toString().padStart(2, '0');
            const paddedDay = day.toString().padStart(2, '0');
            return `${year}/${paddedMonth}/${paddedDay}`;
        };

        const formattedDateCallback = formatDate(selectedDateCallback);


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {

                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }




                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_cheakbox");
        fd.append("id", request_id);
        fd.append("cheak_box_desc", call_back_desc);
        fd.append("isChecked", isChecked);
        fd.append("formattedDateCallback", formattedDateCallback);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };

    handleChangeCheakbox2 = (request_id) => {
        var self = this;

        const {
            insuranceType,
            selectedCompany,
            thirdpartyInsurancePrice,
            ThirdpartyPaymentType,
            ThirdpartyPostingType,
            selectedThirdpartyDateOfSubmission,
            thirdparty_postal_code,
            thirdpartyAddress,
            thirdpartyShippingAddress,
            thirdpartySameAddress,
            bodyCarInsurancePrice,
            BodycarPaymentType,
            BodycarPostingType,
            BodycarVisitType,
            selectedBodycarDateOfSubmission,
            selectedBodycarDateOfVisit,
            bodycar_postal_code,
            bodycarAddress,
            bodycarShippingAddress,
            bodycarSameAddress
        } = this.state;
        console.log('thirdparty_postal_code',thirdparty_postal_code)
        const { selectedDayEnd } = this.state;
        const { selectedDayStart } = this.state;

        const formatDate = ({ day, month, year }) => {
                const paddedMonth = month.toString().padStart(2, '0');
                const paddedDay = day.toString().padStart(2, '0');
                return `${year}/${paddedMonth}/${paddedDay}`;
            };

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {

                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }
                } else if (arr.result === "error") {

                            self.setState({ snackstr: arr.message, showSnack: true, snackMode: "error" })

                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        };

        var fd = new FormData();
        fd.append("command", "add_issuance");
        fd.append("insuranceType", insuranceType);
        fd.append("id", request_id);


        if (insuranceType === 'thirdparty') {
            if (selectedThirdpartyDateOfSubmission !=null ) {
                const formattedDate = formatDate(selectedThirdpartyDateOfSubmission);
                fd.append("dateOfSubmission", formattedDate);
            }

            fd.append("company", selectedCompany ? selectedCompany.value : "");
            fd.append("insurancePrice", thirdpartyInsurancePrice);
            fd.append("paymentType", ThirdpartyPaymentType ? ThirdpartyPaymentType.value : "");
            fd.append("paymentTypeName", ThirdpartyPaymentType ? ThirdpartyPaymentType.label : "");
            fd.append("postingType", ThirdpartyPostingType ? ThirdpartyPostingType.value : "");
            fd.append("postingTypeName", ThirdpartyPostingType ? ThirdpartyPostingType.label : "");
            fd.append("postalCode", thirdparty_postal_code);
            fd.append("address", thirdpartyAddress);
            fd.append("shippingAddress", thirdpartyShippingAddress);
            fd.append("sameAddress", thirdpartySameAddress);

        } else if (insuranceType === 'bodily') {
            if (selectedBodycarDateOfSubmission !=null) {
                const formattedDate = formatDate(selectedBodycarDateOfSubmission);
                fd.append("dateOfSubmission", formattedDate);
            }
            if (selectedBodycarDateOfVisit !=null) {
                const formattedDate = formatDate(selectedBodycarDateOfVisit);
                fd.append("dateOfVisit", formattedDate);
            }
            fd.append("company", selectedCompany ? selectedCompany.value : "");
            fd.append("insurancePrice", bodyCarInsurancePrice);
            fd.append("paymentType", BodycarPaymentType ? BodycarPaymentType.value : "");
            fd.append("paymentTypeName", BodycarPaymentType ? BodycarPaymentType.label : "");
            fd.append("postingType", BodycarPostingType ? BodycarPostingType.value : "");
            fd.append("postingTypeName", BodycarPostingType ? BodycarPostingType.label : "");
            fd.append("visitType", BodycarVisitType ? BodycarVisitType.value : "");
            fd.append("visitTypeName", BodycarVisitType ? BodycarVisitType.label : "");
            fd.append("postalCode", bodycar_postal_code);
            fd.append("address", bodycarAddress);
            fd.append("shippingAddress", bodycarShippingAddress);
            fd.append("sameAddress", bodycarSameAddress);
        }



        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);



    };



    handleClick = (event, rowId) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedRowId: rowId,
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
            selectedRowId: null,
        });
    };


    handleCallStatusUpdate2 = (smsStatus) => {
        const { currentRowId ,selectedDayStart , selectedDayEnd} = this.state;


        this.handleClose(); // بستن منو

        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                    if (selectedDayStart && selectedDayEnd ) {
                        self.datafilter(); // دریافت و به‌روزرسانی داده‌ها


                    }else {
                        self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها

                    }

                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "change_is_called");
        fd.append("id", currentRowId);
        fd.append("call_status_id", smsStatus);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };


    handleResendSms = (id) => {
        const { currentRowId } = this.state;


        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    self.getSmsReceiver(); // دریافت و به‌روزرسانی داده‌ها
                } else if (arr.result === "error") {
                    // در صورت خطا، هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });

                // پس از به‌روزرسانی داده‌ها، مرتب‌سازی دوباره اعمال می‌شود
                // self.applySorting(); // فراخوانی تابع برای اعمال مرتب‌سازی دوباره
            }
        };

        var fd = new FormData();
        fd.append("command", "resend_sms");
        fd.append("excel_name", "naft");
        fd.append("id", id);

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    };





    handleSelectRows = (row2) => {
        this.setState(
            {
                id: row2.id,
                accident_main_coverage_name: row2.accident_main_coverage_name,
                insurer: row2.insurer,
                full_name: row2.full_name,
                typePolicy: row2.typePolicy,
                beginDate: row2.beginDate,
                endDate: row2.endDate,
                sms_date: row2.sms_date,
                excel_name: row2.excel_name,
                vehicalName: row2.vehicalName,
                plateNumber: row2.plateNumber,
                productionDate: row2.productionDate,
                relation: row2.relation,
                parent_name: row2.parent_name,
                policyholder: row2.policyholder,
                phone_number: row2.phone_number,
                personnel_no: row2.personnel_no,
                management_name: row2.management_name,
                company_name: row2.company_name,
                nationalCode: row2.nationalCode,
                message_content: row2.message_content,
                resend_sms: row2.resend_sms,
                discountFinance: row2.discountFinance,
                discountLife: row2.discountLife,
                discountDriver: row2.discountDriver,
                lastPolicyNumber: row2.lastPolicyNumber,
                policyNumber: row2.policyNumber,
                policyUniqueCode: row2.policyUniqueCode,
                engineNumber: row2.engineNumber,
                chassisNo: row2.chassisNo,
                vin: row2.vin,
                call_back_desc: row2.call_back_desc,
                call_back_date: row2.call_back_date,
                call_back_status: row2.call_back_status,
                employee_id: row2.employee_id,
                auth_id: row2.auth_id,
                is_called: row2.is_called,
                last_status: row2.last_status,
                request_id: row2.request_id,
                thirdpartyInsurancePrice: row2.insurancePrice,
                newAccidentMainCoverage: false,
            },
            () => {}
        )
    }




    toggleEmployeeFilter = () => {
        this.setState(prevState => ({
            isEmployeeFilterActive: !prevState.isEmployeeFilterActive
        }));
    };
    newAccidentMainCoverage = (event) => {
        this.setState({
            id: "",
            accident_main_coverage_name: "",
            insurer: "",
            newAccidentMainCoverage: true,
        })
    }
    componentDidMount() {
        if (!this.cookies.get("employee_token_str")) {
            this.setState({ redirect: true });
            return;
        }

        this.props.props.props.dispatch({ type: "WAITSHOW" });

        const self = this;

        const fd = new FormData();
        fd.append("command", "checkemployeelogin");

        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const arr = JSON.parse(this.responseText);
                if (arr.result === "ok") {
                    Promise.all([
                        MarketerBaseService.getPostingType(),
                        MarketerBaseService.getPeymentType(),
                        MarketerBaseService.getVisitType(),
                        MarketerBaseService.getCompany()
                    ])
                        .then(([PostingType, PeymentType, VisitType, Company]) => {
                            self.setState({
                                optionPostingType: PostingType,
                                optionPeymentType: PeymentType,
                                optionVisitType: VisitType,
                                optionCompany: Company
                            });
                        })
                        .catch(err => self.setState({ snackstr: err, showSnack: true, snackMode: "error" }));

                    self.getSmsReceiverStatus();
                    self.getSmsReceiver();

                } else if (arr.result === "error") {
                    self.setState({ redirect: true });
                }

                self.props.props.props.dispatch({ type: "WITEHIDE" });
            }
        };

        xhttp.open("POST", `${constants.BASE_URL}/employeelogin`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }






    getSmsReceiver = () => {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        });
        this.setState({
            selectedDayEnd: "",
            selectedDayStart: "",
            selectedStatus: "",
        });

        var self = this;
        var xhttp = new XMLHttpRequest();

        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText);

                if (arr.result === "ok") {
                    // ذخیره داده‌ها در state
                    self.setState(
                        {
                            requestinfos: arr.data,
                            agentInfofilter: arr.data
                        },
                        () => {
                            // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                            self.applySorting(); // مرتب‌سازی داده‌ها
                        }
                    );
                } else if (arr.result === "error") {
                    // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                }

                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                });
            }
        };

        var fd = new FormData();
        fd.append("command", "get_my_requests");

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
        xhttp.send(fd);
    }


    handleCallStatusUpdate3 = (row) => {


        const nationalCode = row.nationalCode;
        const plate = row.plateNumber;
        const regex = /^([0-9\u06F0-\u06F9]{2})ایران([0-9\u06F0-\u06F9]{3})([آ-ی])([0-9\u06F0-\u06F9]{2})$/;

        const match = plate.match(regex);

            const lastTwo = match[1];   // "33"
            const threeDigits = match[2]; // "438"
            const letter = match[3];      // "ج"
            const twoDigits = match[4];     // "75"

            console.log("دو رقم اول:", twoDigits);
            console.log("سه رقم وسط:", threeDigits);
            console.log("حرف:", letter);
            console.log("دو رقم آخر:", lastTwo);

        // const url = `http://localhost:3000/thirdparty?nationalCode=${nationalCode}&start=${twoDigits}&middle=${threeDigits}&letter=${letter}&end=${lastTwo}`;
        const url = `https://user2.rahnamayefarda.ir/thirdparty?nationalCode=${nationalCode}&start=${twoDigits}&middle=${threeDigits}&letter=${letter}&end=${lastTwo}`;

        console.log("URL ساخته شده:", url);
        window.open(url, "_blank");

        // window.open(`http://localhost:3000/thirdparty2?id=${id}`, "_blank");



        // اینجا کد بروزرسانی وضعیت را اضافه کنید
    };


    getSmsReceiverStatus() {
        this.props.props.props.dispatch({
            type: "WAITSHOW",
        })
        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                if (arr.result === "ok") {
                    self.setState({ requestinfos: arr.data, agentInfofilter2: arr.data }, () => {})
                } else if (arr.result === "error") {
                }
                self.props.props.props.dispatch({
                    type: "WITEHIDE",
                })
            }
        }
        var fd = new FormData()
        fd.append("command", "get_sms_status_one")

        xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }



    // تابع برای اعمال مرتب‌سازی دوباره بر اساس فیلد و وضعیت مرتب‌سازی
    applySorting = () => {
        const { orderBy2, order2 } = this.state;
        const arrayTemp = [...this.state.agentInfofilter];

        // مرتب‌سازی بر اساس فیلدهای مختلف
        arrayTemp.sort((a, b) => {
            let comparisonResult = 0;

            // مقایسه داده‌ها در ترتیب اولویت
            for (let i = 0; i < orderBy2.length; i++) {
                const field = orderBy2[i];
                const orderDirection = order2[i];

                const valueA = field === 'endDate' ? new Date(a[field]) : a[field];
                const valueB = field === 'endDate' ? new Date(b[field]) : b[field];

                if (orderDirection === 'asc') {
                    comparisonResult = valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
                } else {
                    comparisonResult = valueA > valueB ? -1 : (valueA < valueB ? 1 : 0);
                }

                if (comparisonResult !== 0) break; // اگر مقایسه‌ها نتیجه‌دار شدند، دیگر مقایسه نمی‌کنیم
            }

            return comparisonResult;
        });

        // به‌روزرسانی state با داده‌های مرتب‌شده
        this.setState({ agentInfofilter: arrayTemp });
    };




    createSortHandler = (field) => {
        const { orderBy2, order2 } = this.state;

        const fieldIndex = orderBy2.indexOf(field);

        // اگر فیلد جدید است، آن را به لیست اضافه می‌کنیم
        if (fieldIndex === -1) {
            this.setState(
                {
                    orderBy2: [...orderBy2, field],
                    order2: [...order2, 'asc'], // پیش‌فرض ترتیب صعودی است
                },
                this.applySorting
            );
        } else {
            // اگر فیلد قبلاً وجود دارد، ترتیب آن را تغییر می‌دهیم
            const newOrder = [...order2];
            newOrder[fieldIndex] = newOrder[fieldIndex] === 'asc' ? 'desc' : 'asc';

            this.setState(
                {
                    order2: newOrder
                },
                this.applySorting
            );
        }
    };


    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
    }

    handleChangePage = (event, number) => {
        this.setState({ page: parseInt(number, 0) })
    }
    filterRows = () => {

        const { agentInfofilter, isEmployeeFilterActive, searchText } = this.state;

        return agentInfofilter
            .filter((row) => {
                if (isEmployeeFilterActive && row.employee_id !== row.auth_id) return false;

                if (!searchText.trim()) return true;

                const lowerSearch = searchText.toLowerCase();

                // چک کن ببین آیا حداقل یکی از فیلدها شامل سرچ هست
                return Object.values(row).some((value) =>
                    String(value).toLowerCase().includes(lowerSearch)
                );
            });
    };

    datafilter = () => {


        const { selectedDayStart, selectedDayEnd, searchText, selectedStatus } = this.state;

        if (selectedDayStart && selectedDayEnd ) {
            // همه دارای مقدار هستن
            const formatDate = ({ day, month, year }) => {
                const paddedMonth = month.toString().padStart(2, '0');
                const paddedDay = day.toString().padStart(2, '0');
                return `${year}/${paddedMonth}/${paddedDay}`;
            };

            const formattedStartDate = formatDate(selectedDayStart);
            const formattedEndDate = formatDate(selectedDayEnd);
            const selectedStatusId = selectedStatus;

            // Dispatch action to show waiting state
            this.props.props.props.dispatch({
                type: "WAITSHOW",
            });

            // استفاده از XMLHttpRequest برای ارسال داده‌ها
            var xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = () => {  // استفاده از تابع پیکانی
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    var arr = JSON.parse(xhttp.responseText);

                    if (arr.result === "ok") {
                        // ذخیره داده‌ها در state
                        this.setState(
                            {
                                requestinfos: arr.data,
                                agentInfofilter: arr.data
                            },
                            () => {
                                // بعد از ذخیره داده‌ها، مرتب‌سازی را اعمال می‌کنیم
                                this.applySorting(); // مرتب‌سازی داده‌ها
                            }
                        );
                    } else if (arr.result === "error") {
                        // در صورت بروز خطا هیچ عملی انجام نمی‌دهیم
                    }

                    // Dispatch action to hide waiting state
                    this.props.props.props.dispatch({
                        type: "WITEHIDE",
                    });
                }
            };

            var fd = new FormData();
            fd.append("command", "get_my_requests");
            fd.append("StartDate", formattedStartDate);
            fd.append("EndDate", formattedEndDate);
            fd.append("StatusId", selectedStatusId);

            xhttp.open("POST", `${constants.BASE_URL}/MarketersPanel`);
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"));
            xhttp.send(fd);
        }else {

            this.setState({ snackstr: "لطفا تاریخ شروع و پایان را وارد کنید", showSnack: true, snackMode: "error" })

        }


    };

    handleInsuranceTypeChange = (selectedOption,row) => {
        console.log('selectedOption',selectedOption)
        this.setState({
            insuranceType: selectedOption.value,
            selectedCompany: ""
        });



        if (selectedOption.value === "bodily") {



            this.setState({
                selectedCompany: this.state.optionCompany.find(
                    option => option.value === row.bodycarCompany
                ) || null,

                BodycarPaymentType: this.state.optionPeymentType.find(
                    option => option.value === row.BodycarPaymentType
                ) || null,
                BodycarPostingType: this.state.optionPostingType.find(
                    option => option.value === row.BodycarPostingType
                ) || null,
                BodycarVisitType: this.state.optionVisitType.find(
                    option => option.value === row.BodycarVisitType
                ) || null,


                bodyCarInsurancePrice: row.bodyCarInsurancePrice,
                // selectedBodycarDateOfSubmission: row.selectedBodycarDateOfSubmission,
                bodycar_postal_code: row.bodycar_postal_code,
                bodycarAddress: row.bodycarAddress,
                bodycarShippingAddress: row.bodycarShippingAddress,

            });
        }
        if (row.bodycarSameAddress) {

            this.setState({'bodycarSameAddress':    row.bodycarSameAddress})
        }


        if (selectedOption.value === "thirdparty") {
            this.setState({
                selectedCompany: this.state.optionCompany.find(
                    option => option.value === row.thirdpartyCompany
                ) || null,

                ThirdpartyPaymentType: this.state.optionPeymentType.find(
                    option => option.value === row.thirdpartyPaymentType
                ) || null,
                ThirdpartyPostingType: this.state.optionPostingType.find(
                    option => option.value === row.thirdpartyPostingType
                ) || null,
                thirdpartyInsurancePrice: row.thirdpartyInsurancePrice,
                // selectedBodycarDateOfVisit: row.selectedBodycarDateOfVisit,
                // selectedBodycarDateOfSubmission: row.selectedBodycarDateOfSubmission,
                thirdparty_postal_code: row.thirdparty_postal_code,
                thirdpartyAddress: row.thirdpartyAddress,
                thirdpartyShippingAddress: row.thirdpartyShippingAddress,

            });
        }
        if (row.thirdpartySameAddress) {

            this.setState({ thirdpartySameAddress: row.thirdpartySameAddress });
        }



    };
    handleCompanyChange = (selectedCompany) => {
        this.setState({ selectedCompany });
    };

    handleThirdpartyPaymentType = (ThirdpartyPaymentType) => {
        console.log('asli',ThirdpartyPaymentType)
        this.setState({ ThirdpartyPaymentType });
    };
    handleBodycarPaymentType = (BodycarPaymentType) => {
        this.setState({ BodycarPaymentType });
    };

  handleThirdpartyPostingType = (ThirdpartyPostingType) => {
        this.setState({ ThirdpartyPostingType });
    };
  handleBodycarPostingType = (BodycarPostingType) => {
        this.setState({ BodycarPostingType });
    };
  handleBodycarVisitType = (BodycarVisitType) => {
        this.setState({ BodycarVisitType });
    };




    render() {
        const { anchorEl } = this.state; // موقعیت منو
        const { orderBy2, order2 } = this.state;
        const { classes } = this.props
        const {
            BodycarPaymentType,
            ThirdpartyPaymentType,
            ThirdpartyPostingType,
            BodycarPostingType,
            BodycarVisitType,
            selectedCompany,
            optionCompany,
            optionPostingType,
            optionVisitType,
            optionPeymentType,
            thirdpartyInsurancePrice,
            thirdpartyAddress,
            thirdpartyShippingAddress,
            thirdpartySameAddress,
            bodycarAddress,
            bodycarShippingAddress,
            bodycarSameAddress,
            bodyCarInsurancePrice,
            optionTherapyInsurer,
            selectedTherapyInsurer,
            agentPermision,
            snackMode,
            snackstr,
            showSnack,
            isEmployeeFilterActive,
            newAccidentMainCoverage,
            id,
            accident_main_coverage_name,
            searchText,
            insurer,
            full_name,
            typePolicy,
            beginDate,
            endDate,
            vehicalName,
            plateNumber,
            policyholder,
            phone_number,
            nationalCode,
            message_content,
            call_back_desc,
            thirdparty_postal_code,
            bodycar_postal_code,
            call_back_date,
            selectedDayEnd,
            selectedDayStart,
            selectedDateCallback,
            selectedThirdpartyDateOfSubmission,
            selectedBodycarDateOfSubmission,
            call_back_status,
            discountFinance,
            discountLife,
            discountDriver,
            lastPolicyNumber,
            policyNumber,
            policyUniqueCode,
            engineNumber,
            is_called,
            order,
            orderBy,
            okstatus,
            errstr,
            redirect,
            agentInfofilter,
            agentInfofilter2,
            rowsPerPage,
            page,
            cheak_box_desc,

        } = this.state


        if (redirect) {
            return <Redirect to="/" />
        } else {
            return (
                <div className={classes.paperrtl} dir="ltr">
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Container maxWidth="xl">

                                <FilterPanel
                                    className={classes.root}
                                    searchText={this.state.searchText}
                                    onSearchTextChange={(val) => this.setState({ searchText: val })}
                                    selectedDayStart={this.state.selectedDayStart}
                                    onStartDateChange={(val) => this.setState({ selectedDayStart: val })}
                                    selectedDayEnd={this.state.selectedDayEnd}
                                    onEndDateChange={(val) => this.setState({ selectedDayEnd: val })}
                                    selectedStatus={this.state.selectedStatus}
                                    onStatusChange={(val) => this.setState({ selectedStatus: val })}
                                    statusOptions={agentInfofilter2.map(item => ({
                                        value: item.sms_status_id,
                                        label: item.sms_status
                                    }))}
                                    onSearch={this.datafilter}
                                    onBase={this.getSmsReceiver}
                                    excel='Marketer'

                                />

                                <Paper className={classes.root}>
                                    <TableContainer dir="rtl">
                                        <Table aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {/*<TableCell*/}
                                                    {/*    key={"id"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 20 }}*/}
                                                    {/*    sortDirection={orderBy === "id" ? order : false}*/}
                                                    {/*>*/}
                                                    {/*    {"آیدی "}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "id"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "id" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("id")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}

                                                    <TableCell
                                                        key={"insurer"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شرکت بیمه"}
                                                        <TableSortLabel
                                                            active={orderBy === "insurer"}
                                                            direction={
                                                                orderBy === "insurer" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("insurer")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"typePolicy"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"typePolicy"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "typePolicy"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "typePolicy" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("typePolicy")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    {/*<TableCell*/}
                                                    {/* key={"beginDate"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"beginDate"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "beginDate"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "beginDate" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("beginDate")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"endDate"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ پایان"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("endDate")}
                                                            direction={orderBy2.includes("endDate") ? order2[orderBy2.indexOf("endDate")] : "asc"}
                                                            onClick={() => this.createSortHandler("endDate")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"sms_date"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تاریخ ارجاع"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("sms_date")}
                                                            direction={orderBy2.includes("sms_date") ? order2[orderBy2.indexOf("sms_date")] : "asc"}
                                                            onClick={() => this.createSortHandler("sms_date")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"excel_name"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام اکسل"}
                                                        <TableSortLabel
                                                            active={orderBy2.includes("excel_name")}
                                                            direction={orderBy2.includes("excel_name") ? order2[orderBy2.indexOf("excel_name")] : "asc"}
                                                            onClick={() => this.createSortHandler("excel_name")}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        key={"plateNumber"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"پلاک ماشین"}
                                                        <TableSortLabel
                                                            active={orderBy === "plateNumber"}
                                                            direction={
                                                                orderBy === "plateNumber" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("plateNumber")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"policyholder"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"نام/نام خانوادگی"}
                                                        <TableSortLabel
                                                            active={orderBy === "policyholder"}
                                                            direction={
                                                                orderBy === "policyholder" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("policyholder")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"phone_number"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"شماره موبایل"}
                                                        <TableSortLabel
                                                            active={orderBy === "phone_number"}
                                                            direction={
                                                                orderBy === "phone_number" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("phone_number")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/* key={"nationalCode"}*/}
                                                    {/* align={"center"}*/}
                                                    {/* style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/* {"nationalCode"}*/}
                                                    {/* <TableSortLabel*/}
                                                    {/* active={orderBy === "nationalCode"}*/}
                                                    {/* direction={*/}
                                                    {/* orderBy === "nationalCode" ? order : "asc"*/}
                                                    {/* }*/}
                                                    {/* onClick={(e) => {*/}
                                                    {/* this.createSortHandler("nationalCode")*/}
                                                    {/* }}*/}
                                                    {/* ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"message_content"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"متن پیامک"}
                                                        <TableSortLabel
                                                            active={orderBy === "message_content"}
                                                            direction={
                                                                orderBy === "message_content" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("message_content")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    {/*<TableCell*/}
                                                    {/*    key={"resend_sms"}*/}
                                                    {/*    align={"center"}*/}
                                                    {/*    style={{ minWidth: 60 }}*/}
                                                    {/*>*/}
                                                    {/*    {"پیامک مجدد"}*/}
                                                    {/*    <TableSortLabel*/}
                                                    {/*        active={orderBy === "resend_sms"}*/}
                                                    {/*        direction={*/}
                                                    {/*            orderBy === "resend_sms" ? order : "asc"*/}
                                                    {/*        }*/}
                                                    {/*        onClick={(e) => {*/}
                                                    {/*            this.createSortHandler("resend_sms")*/}
                                                    {/*        }}*/}
                                                    {/*    ></TableSortLabel>*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell
                                                        key={"call_back_desc"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تماس مجدد"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("call_back_status")}
                                                            direction={orderBy2.includes("call_back_status") ? order2[orderBy2.indexOf("call_back_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("call_back_status")}
                                                        />
                                                    </TableCell>




                                                    <TableCell
                                                        key={"is_called"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"تعیین وضعیت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "is_called"}
                                                            direction={
                                                                orderBy === "is_called" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("is_called")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>
                                                    <TableCell
                                                        key={"last_status"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"آخرین وضعیت"}
                                                        <br />
                                                        <TableSortLabel
                                                            active={orderBy2.includes("last_status")}
                                                            direction={orderBy2.includes("last_status") ? order2[orderBy2.indexOf("last_status")] : "asc"}
                                                            onClick={() => this.createSortHandler("last_status")}
                                                        />
                                                    </TableCell>

                                                    <TableCell
                                                        key={"price"}
                                                        align={"center"}
                                                        style={{ minWidth: 60 }}
                                                    >
                                                        {"قیمت"}
                                                        <br/>
                                                        <TableSortLabel
                                                            active={orderBy === "price"}
                                                            direction={
                                                                orderBy === "price" ? order : "asc"
                                                            }
                                                            onClick={(e) => {
                                                                this.createSortHandler("price")
                                                            }}
                                                        ></TableSortLabel>
                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {/*<div>*/}
                                                {/*    /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                {/*    <Button*/}
                                                {/*        variant="contained"*/}
                                                {/*        color="primary"*/}
                                                {/*        onClick={this.toggleEmployeeFilter}*/}
                                                {/*    >*/}
                                                {/*        {isEmployeeFilterActive ? 'غیرفعال کردن فیلتر' : 'فعال کردن فیلتر'}*/}
                                                {/*    </Button>*/}
                                                {/*</div>*/}


                                                {this.filterRows()
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row) => {
                                                        if (isEmployeeFilterActive && row.employee_id !== row.auth_id) {
                                                            return null;
                                                        }
                                                        const color = row.percentage < 50 ? 'red' : row.percentage < 80 ? 'yellow' : 'green';
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row["id"]}
                                                                value={row}
                                                                onClick={() => {
                                                                    this.
                                                                    gotoDetailRequest(row.id,row.call_back_desc,row.call_back_status,row.call_back_date,row.selectedThirdpartyDateOfSubmission,row.selectedBodycarDateOfSubmission,row.selectedBodycarDateOfVisit)
                                                                }}
                                                                style={{
                                                                    backgroundColor:
                                                                        row.last_status === "در حال بررسی"
                                                                            ? "#F5F5DC" // زرد کرمی
                                                                            : row.last_status === "تمدید شد"
                                                                                ? "#EAF3FB" // سبز ملایم
                                                                                : row.last_status === "بررسی نشده"
                                                                                    ? "#FDEDEC" // قرمز ملایم
                                                                                    : row.last_status === "نهایی شد"
                                                                                        ? "#E6F4EA" // سبز نعناعی ملایم
                                                                                        : "transparent",

                                                                    transition: "background-color 0.3s ease",
                                                                }}
                                                            >
                                                                {/*<TableCell*/}
                                                                {/*    key={"id"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["id"]}*/}
                                                                {/*</TableCell>*/}

                                                                <TableCell
                                                                    key={"insurer"}
                                                                    align={"center"}
                                                                >
                                                                    {row["insurer"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"typePolicy"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["typePolicy"]}*/}
                                                                {/*</TableCell>*/}
                                                                {/*<TableCell*/}
                                                                {/* key={"beginDate"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["beginDate"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"endDate"}
                                                                    align={"center"}
                                                                >
                                                                    {row["endDate"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"sms_date"}
                                                                    align={"center"}
                                                                >
                                                                    {row["sms_date"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"excel_name"}
                                                                    align={"center"}
                                                                >
                                                                    {row["excel_name"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/* key={"vehicalName"}*/}
                                                                {/* align={"center"}*/}
                                                                {/*>*/}
                                                                {/* {row["vehicalName"]}*/}
                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"plateNumber"}
                                                                    align={"center"}
                                                                >
                                                                    {row["plateNumber"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"policyholder"}
                                                                    align={"center"}
                                                                >
                                                                    {row["policyholder"]}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"phone_number"}
                                                                    align={"center"}
                                                                >
                                                                    {row["phone_number"]}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"message_content"}
                                                                    align={"center"}
                                                                >
                                                                    {row["message_content"]}
                                                                </TableCell>
                                                                {/*<TableCell*/}
                                                                {/*    key={"resend_sms"}*/}
                                                                {/*    align={"center"}*/}
                                                                {/*>*/}
                                                                {/*    {row["resend_sms"]}*/}
                                                                {/*    <div>*/}
                                                                {/*        /!* دکمه برای فعال/غیرفعال کردن شرط *!/*/}
                                                                {/*        <Button*/}
                                                                {/*            variant="contained"*/}
                                                                {/*            color="primary"*/}
                                                                {/*            disabled={row["resend_sms"] == 1 || row["excel_name"] == 'مشتری های قدیمی' }*/}

                                                                {/*            onClick={(event) => {*/}
                                                                {/*                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک*/}
                                                                {/*                this.handleResendSms(row.id);*/}
                                                                {/*            }}*/}

                                                                {/*        >*/}

                                                                {/*            پیامک مجدد*/}
                                                                {/*        </Button>*/}
                                                                {/*    </div>*/}


                                                                {/*</TableCell>*/}
                                                                <TableCell
                                                                    key={"call_back_desc"}
                                                                    align={"center"}
                                                                    style={{
                                                                        backgroundColor: row["call_back_status"] === "true" ? "green" : "transparent", // سبز در حالت true
                                                                        color: row["call_back_status"] === "true" ? "white" : "inherit", // متن سفید فقط در حالت true
                                                                    }}
                                                                >
                                                                    {/*{row["call_back_status"] === "true" ? "بله" : "خیر"}*/}
                                                                    <br />
                                                                    {row["call_back_date"]}
                                                                </TableCell>




                                                                <TableCell align="center">
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={(event) => this.handleClick(event, row.id)}
                                                                    >
                                                                        انتخاب وضعیت
                                                                    </Button>

                                                                    {this.state.selectedRowId === row.id && (
                                                                        <Menu
                                                                            anchorEl={this.state.anchorEl}
                                                                            open={Boolean(this.state.anchorEl)}
                                                                            onClose={this.handleClose}

                                                                            TransitionComponent={Grow}
                                                                            TransitionProps={{ timeout: 600 }} // برای زمان انیمیشن

                                                                        >
                                                                            {agentInfofilter2.map((item, index) => (
                                                                                <MenuItem
                                                                                    key={index}
                                                                                    onClick={(event) => {
                                                                                        event.stopPropagation();
                                                                                        this.setState({ currentRowId: row.id }, () => {
                                                                                            this.handleCallStatusUpdate2(item.sms_status_id);
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    {item.sms_status}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Menu>
                                                                    )}
                                                                </TableCell>

                                                                <TableCell
                                                                    key={"last_status"}
                                                                    align={"center"}
                                                                >
                                                                    {row["last_status"]}
                                                                    {<h5> ({row["full_name"]}) </h5>}
                                                                </TableCell>
                                                                <TableCell
                                                                    key={"price"}
                                                                    align={"center"}
                                                                >


                                                                    <div>
                                                                        {/* دکمه برای فعال/غیرفعال کردن شرط */}
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"

                                                                            onClick={(event) => {
                                                                                event.stopPropagation(); // جلوگیری از انتشار رویداد کلیک
                                                                                this.handleCallStatusUpdate3(row);
                                                                            }}
                                                                            // disabled

                                                                        >

                                                                            قیمت$
                                                                        </Button>
                                                                    </div>

                                                                </TableCell>

                                                            </TableRow>
                                                        )
                                                    })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 100]}
                                        component="div"
                                        count={this.filterRows().length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </Paper>
                            </Container>

                            <Container component="main" maxWidth="lg">

                                <Container maxWidth="lg">
                                    {agentInfofilter
                                        .map((row) => {
                                            const color = this.state['request_id'];
                                            if (color === row.id) {
                                                return (
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="vertical table">
                                                            <TableBody style={{ textAlign: "center" , direction: "rtl",}}>
                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گر</TableCell> {/* insurer */}
                                                                    <TableCell align="center">{row.insurer}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نوع بیمه‌نامه</TableCell> {/* typePolicy */}
                                                                    <TableCell align="center">{row.typePolicy}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تاریخ شروع</TableCell> {/* beginDate */}
                                                                    <TableCell align="center">{row.beginDate}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام خودرو</TableCell> {/* vehicalName */}
                                                                    <TableCell align="center">{row.vehicalName}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پلاک</TableCell> {/* plateNumber */}
                                                                    <TableCell align="center">{row.plateNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">سال خودرو</TableCell> {/* plateNumber */}
                                                                    <TableCell align="center">{row.productionDate}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نسبت با سرپرست</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.relation}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام سرپرست (در صورت وجود)</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.parent_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">بیمه‌گذار</TableCell> {/* policyholder */}
                                                                    <TableCell align="center">{row.policyholder}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موبایل</TableCell> {/* phone_number */}
                                                                    <TableCell align="center">{row.phone_number}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره پرسنلی</TableCell> {/* personnel_no */}
                                                                    <TableCell align="center">{row.personnel_no}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام مدیریت</TableCell> {/* management_name */}
                                                                    <TableCell align="center">{row.management_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">نام شرکت</TableCell> {/* company_name */}
                                                                    <TableCell align="center">{row.company_name}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد ملی</TableCell> {/* nationalCode */}
                                                                    <TableCell align="center">{row.nationalCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف مالی</TableCell> {/* discountFinance */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountFinance"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountFinance"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                } />
                                                                        </div>
                                                                        {row["discountFinance"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف جانی</TableCell> {/* discountLife */}
                                                                    <TableCell style={{ textAlign: "-webkit-center" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountLife"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountLife"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountLife"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">تخفیف راننده</TableCell> {/* discountDriver */}
                                                                    <TableCell style={{ textAlign: "-webkit-center", direction: "rtl" }}>
                                                                        <div className={classes.progressContainer}>
                                                                            <LinearProgress
                                                                                className={classes.progress}
                                                                                variant="determinate"
                                                                                value={
                                                                                    row["discountDriver"].match(/\((-?\d+)%\)/)
                                                                                        ? Math.max(0, parseFloat(row["discountDriver"].match(/\((-?\d+)%\)/)[1]))
                                                                                        : 0
                                                                                }
                                                                            />
                                                                        </div>
                                                                        {row["discountDriver"]}
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه قبلی</TableCell> {/* lastPolicyNumber */}
                                                                    <TableCell align="center">{row.lastPolicyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره بیمه‌نامه</TableCell> {/* policyNumber */}
                                                                    <TableCell align="center">{row.policyNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد یکتای بیمه‌نامه</TableCell> {/* policyUniqueCode */}
                                                                    <TableCell align="center">{row.policyUniqueCode}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره موتور</TableCell> {/* engineNumber */}
                                                                    <TableCell align="center">{row.engineNumber}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">شماره شاسی</TableCell> {/* chassisNo */}
                                                                    <TableCell align="center">{row.chassisNo}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">کد VIN</TableCell> {/* vin */}
                                                                    <TableCell align="center">{row.vin}</TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    <TableCell align="center">توضیح تماس بعدی</TableCell> {/* Call back */}
                                                                    <TableCell align="center">{row.call_back_desc}</TableCell>
                                                                </TableRow>

                                                            </TableBody>
                                                        </Table>


                                                        <Container maxWidth="lg">
                                                            <Paper className={classes.root}>
                                                                <Grid container>
                                                                    <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                            placeholder="توضیحات"
                                                                            handleInputt={this.handleChangeDesc} // متدی که استیت را به‌روزرسانی می‌کند
                                                                            value={call_back_desc} // مقدار از state گرفته می‌شود
                                                                        />
                                                                    </Grid>
                                                                    {console.log("aaaaaaa",row.call_back_status)}

                                                                    <Grid item xs={4}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.isChecked === "true"}  // مقایسه رشته‌ای با "true"
                                                                                    onChange={this.handleCheckboxChange}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label={this.state.isChecked === "true" ? "Yes" : "No"}  // مقایسه رشته‌ای برای تعیین label
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Typography variant="body1" style={{ marginBottom: 8 }}>تاریخ تماس مجدد</Typography>
                                                                        <Calendar
                                                                            renderInput={({ ref }) => (
                                                                                <TextField
                                                                                    fullWidth
                                                                                    inputRef={ref}
                                                                                    variant="outlined"
                                                                                    value={
                                                                                        this.state.selectedDateCallback
                                                                                            ? `${this.state.selectedDateCallback.year}/${String(this.state.selectedDateCallback.month).padStart(2, '0')}/${String(this.state.selectedDateCallback.day).padStart(2, '0')}`
                                                                                            : ''
                                                                                    }
                                                                                    placeholder="تاریخ تماس مجدد"
                                                                                />
                                                                            )}
                                                                            value={this.state.selectedDateCallback}
                                                                            onChange={(val) => this.setselectedDateCallback(val)}
                                                                            locale="fa"
                                                                            shouldHighlightWeekends
                                                                        />
                                                                    </Grid>


                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={() => {
                                                                            this.handleChangeCheakbox(this.state.request_id);
                                                                        }}
                                                                    >
                                                                        ثبت
                                                                    </Button>
                                                                </Grid>
                                                            </Paper>
                                                        </Container>


                                                        <Container maxWidth="lg">
                                                            <Paper style={{ minHeight: '200px' }} className={classes.root}>

                                                                <Grid item xs={12}>
                                                                    <label className="on">نوع بیمه</label>

                                                                    <FormControl fullWidth variant="outlined" style={{ marginTop: 16 }} dir="rtl">
                                                                        <InputLabel
                                                                            id="insurance-type-label"
                                                                            style={{
                                                                                direction: "rtl",
                                                                                right: 30,
                                                                                left: "unset",
                                                                                transformOrigin: "top right",
                                                                                textAlign: "right",
                                                                            }}
                                                                        >
                                                                        </InputLabel>
                                                                        <CustomSelect
                                                                            options={[
                                                                                { value: 'thirdparty', label: 'ثالث' },
                                                                                { value: 'bodily', label: 'بدنه' }
                                                                            ]}
                                                                            value={{ value: this.state.insuranceType, label: this.state.insuranceType === 'thirdparty' ? 'ثالث' : 'بدنه' }}
                                                                            // onChange={(selectedOption) =>
                                                                            //     this.setState({
                                                                            //         insuranceType: selectedOption.value,
                                                                            //         selectedCompany: ""
                                                                            //     })
                                                                            // }
                                                                            onChange={(selectedOption) => this.handleInsuranceTypeChange(selectedOption, row)}
                                                                        />
                                                                    </FormControl>
                                                                </Grid>


                                                                {this.state.insuranceType === 'thirdparty' && (
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                                <div style={{ border: !selectedCompany ? "1px solid red" : "none", borderRadius: 4 }}>

                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="شرکت بیمه"
                                                                                    // value={selectedCompany}
                                                                                    value={selectedCompany || ""}

                                                                                    onChange={this.handleCompanyChange}
                                                                                    options={optionCompany}
                                                                                    isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4}>
                                                                            <FloatingLabelInput
                                                                                type="currency"
                                                                                placeholder="مبلغ بیمه"
                                                                                handleInputt={this.handleChangethirdpartyInsurancePrice}
                                                                                value={thirdpartyInsurancePrice || ""}
                                                                                error={(thirdpartyInsurancePrice ||"") === ""}
                                                                                helperText={(thirdpartyInsurancePrice|| "") === "" ? "مبلغ بیمه الزامی است" : ""}
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>

                                                                                <div style={{ border: !ThirdpartyPaymentType  ? "1px solid red" : "none", borderRadius: 4 }}>


                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="نحوه پرداخت"
                                                                                    value={ThirdpartyPaymentType|| ""}
                                                                                    onChange={this.handleThirdpartyPaymentType}
                                                                                    options={optionPeymentType}
                                                                                    // isDisabled={row.thirdpartyPaymentType}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        {/* ردیف دوم */}
                                                                        <Grid item xs={12} sm={4}>
                                                                                <div style={{ border: !ThirdpartyPostingType? "1px solid red" : "none", borderRadius: 4 }}>

                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="نحوه ارسال"
                                                                                    value={ThirdpartyPostingType || ""}

                                                                                    onChange={this.handleThirdpartyPostingType}
                                                                                    options={optionPostingType}
                                                                                    isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4}>
                                                                            <Calendar
                                                                                containerClassName="datepicker-fix"
                                                                                renderInput={({ ref }) => (
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        inputRef={ref}
                                                                                        variant="outlined"
                                                                                        value={
                                                                                            this.state.selectedThirdpartyDateOfSubmission
                                                                                                ? `${this.state.selectedThirdpartyDateOfSubmission.year}/${String(this.state.selectedThirdpartyDateOfSubmission.month).padStart(2, "0")}/${String(this.state.selectedThirdpartyDateOfSubmission.day).padStart(2, "0")}`
                                                                                                : ""
                                                                                        }
                                                                                        placeholder="تاریخ ارسال"
                                                                                        // error={!this.state.selectedThirdpartyDateOfSubmission}
                                                                                        // helperText={!this.state.selectedThirdpartyDateOfSubmission ? "تاریخ الزامی است" : ""}
                                                                                    />
                                                                                )}
                                                                                value={this.state.selectedThirdpartyDateOfSubmission}
                                                                                onChange={(val) => this.setselectedThirdpartyDateOfSubmission(val)}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '-20px' }}>
                                                                            <FloatingLabelInput
                                                                                placeholder="کد پستی"
                                                                                handleInputt={this.handleThirdpartyPostalCode}
                                                                                value={thirdparty_postal_code || ""}
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                            />
                                                                        </Grid>

                                                                        {/* ردیف سوم */}

                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                className="adapter-txtsize"
                                                                                error={ (thirdpartyAddress === "" && (!row.thirdpartyAddress || row.thirdpartyAddress === "")) }
                                                                                helperText={ (thirdpartyAddress === "" && (!row.thirdpartyAddress || row.thirdpartyAddress === "")) ? "آدرس الزامی است" : "" }

                                                                                placeholder="آدرس دقیق"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={3}
                                                                                value={thirdpartyAddress || row.thirdpartyAddress || ""}
                                                                                onChange={this.handlethirdpartyAddress}
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                            آدرس ارسال همان آدرس بیمه نامه هم هست؟
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.thirdpartySameAddress === "true"} // چک با رشته
                                                                                        onChange={(e) => {
                                                                                            const checked = e.target.checked ? "true" : "false"; // تبدیل به رشته
                                                                                            console.log("thirdpartySameAddress:", checked);
                                                                                            this.setState({ thirdpartySameAddress: checked });
                                                                                        }}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label={this.state.thirdpartySameAddress === "true" ? "بله" : "خیر"}
                                                                            />
                                                                        </Grid>

                                                                        {this.state.thirdpartySameAddress === "false" && (                                                                            <Grid item xs={9}>
                                                                                <TextField
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="آدرس دقیق ارسال"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={3}
                                                                                    value={
                                                                                        thirdpartyShippingAddress || row.thirdpartyShippingAddress || ""
                                                                                    }
                                                                                    onChange={this.handlethirdpartyShippingAddress}
                                                                                    disabled={row["last_status"] !== "در حال بررسی"} // اگه تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </Grid>
                                                                        )}



                                                                        {!row.last_status["last_status"] !== 'در حال بررسی' && (


                                                                            <Grid item xs={12} style={{ textAlign: "left", marginTop: 24 }}>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="primary"
                                                                                size="large"
                                                                                onClick={() => this.handleChangeCheakbox2(this.state.request_id)}
                                                                                startIcon={<i className="fas fa-check-circle"></i>}
                                                                                style={{
                                                                                    borderRadius: "8px",
                                                                                    padding: "10px 24px",
                                                                                    fontSize: "12px",
                                                                                }}
                                                                            >
                                                                                ثبت نهایی
                                                                            </Button>
                                                                        </Grid>
                                                                        )}

                                                                    </Grid>
                                                                )}

                                                                {this.state.insuranceType === 'bodily' && (
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                            <div style={{ border: !selectedCompany ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="شرکت بیمه"
                                                                                    onChange={this.handleCompanyChange}
                                                                                    value={selectedCompany}

                                                                                    options={optionCompany}
                                                                                    isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4}>
                                                                            <FloatingLabelInput
                                                                                type="currency"
                                                                                placeholder="مبلغ بیمه"
                                                                                handleInputt={this.handleChangebodyCarInsurancePrice}

                                                                                value={bodyCarInsurancePrice || ""}
                                                                                error={(bodyCarInsurancePrice || "") === ""}
                                                                                helperText={(bodyCarInsurancePrice|| "") === "" ? "مبلغ بیمه الزامی است" : ""}
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '15px' }}>
                                                                            <div style={{ border: !BodycarPaymentType ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="نحوه پرداخت"
                                                                                    onChange={this.handleBodycarPaymentType}
                                                                                    selectedBodycarPaymentOption

                                                                                    value={BodycarPaymentType || ""}
                                                                                    options={optionPeymentType}
                                                                                    // isDisabled={row.BodycarPaymentType}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4}>
                                                                            <div style={{ border: !BodycarPostingType  ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="نحوه ارسال"
                                                                                    onChange={this.handleBodycarPostingType}
                                                                                    options={optionPostingType}

                                                                                    value={BodycarPostingType || ""}

                                                                                    isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>

                                                                        <Grid item xs={12} sm={4}>
                                                                            <Calendar
                                                                                containerClassName="datepicker-fix"
                                                                                renderInput={({ ref }) => (
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        inputRef={ref}
                                                                                        variant="outlined"
                                                                                        value={
                                                                                            this.state.selectedBodycarDateOfSubmission
                                                                                                ? `${this.state.selectedBodycarDateOfSubmission.year}/${String(this.state.selectedBodycarDateOfSubmission.month).padStart(2, "0")}/${String(this.state.selectedBodycarDateOfSubmission.day).padStart(2, "0")}`
                                                                                                : ""
                                                                                        }
                                                                                        placeholder="تاریخ ارسال"
                                                                                        // error={!this.state.selectedBodycarDateOfSubmission}
                                                                                        // helperText={!this.state.selectedBodycarDateOfSubmission ? "تاریخ الزامی است" : ""}
                                                                                    />
                                                                                )}
                                                                                value={this.state.selectedBodycarDateOfSubmission}
                                                                                onChange={(val) => this.setselectedBodycarDateOfSubmission(val)}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                            />
                                                                        </Grid>





                                                                        <Grid item xs={12} sm={4} style={{ marginTop: '-15px' }}>
                                                                            <FloatingLabelInput
                                                                                placeholder="کد پستی"
                                                                                handleInputt={this.handleBodycarPostalCode}

                                                                                value={bodycar_postal_code || ""}
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={4}>
                                                                            <div style={{ border: !BodycarVisitType ? "1px solid red" : "none", borderRadius: 4 }}>
                                                                                <CustomSelect
                                                                                    isSearchable
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="نوع بازدید"
                                                                                    onChange={this.handleBodycarVisitType}
                                                                                    options={optionVisitType}

                                                                                    value={BodycarVisitType || ""}

                                                                                    isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={4}>
                                                                            <Calendar
                                                                                containerClassName="datepicker-fix"
                                                                                renderInput={({ ref }) => (
                                                                                    <TextField
                                                                                        fullWidth
                                                                                        inputRef={ref}
                                                                                        variant="outlined"
                                                                                        value={
                                                                                            this.state.selectedBodycarDateOfVisit
                                                                                                ? `${this.state.selectedBodycarDateOfVisit.year}/${String(this.state.selectedBodycarDateOfVisit.month).padStart(2, "0")}/${String(this.state.selectedBodycarDateOfVisit.day).padStart(2, "0")}`
                                                                                                : ""
                                                                                        }
                                                                                        placeholder="تاریخ بازدید"
                                                                                        // error={!this.state.selectedBodycarDateOfSubmission}
                                                                                        // helperText={!this.state.selectedBodycarDateOfSubmission ? "تاریخ الزامی است" : ""}
                                                                                    />
                                                                                )}
                                                                                value={this.state.selectedBodycarDateOfVisit}
                                                                                onChange={(val) => this.setselectedBodycarDateOfVisit(val)}
                                                                                locale="fa"
                                                                                shouldHighlightWeekends
                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                className="adapter-txtsize"
                                                                                placeholder="آدرس دقیق"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={3}
                                                                                value={bodycarAddress || ""}

                                                                                onChange={this.handlebodycarAddress}
                                                                                error={ (bodycarAddress === "" && (!row.bodycarAddress || row.bodycarAddress === "")) }
                                                                                helperText={ (bodycarAddress === "" && (!row.bodycarAddress || row.bodycarAddress === "")) ? "آدرس الزامی است" : "" }

                                                                                isDisabled={row["last_status"] !== 'در حال بررسی'}  // اگر مقدار تو row بود، غیرقابل تغییر

                                                                            />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                            آدرس ارسال همان آدرس بیمه نامه هم هست؟
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.bodycarSameAddress === "true"} // چک با رشته
                                                                                        onChange={(e) => {
                                                                                            const checked = e.target.checked ? "true" : "false"; // تبدیل به رشته
                                                                                            this.setState({ bodycarSameAddress: checked });
                                                                                        }}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label={this.state.bodycarSameAddress === "true" ? "بله" : "خیر"}
                                                                            />
                                                                        </Grid>

                                                                        {this.state.bodycarSameAddress ==="false" && (
                                                                            <Grid item xs={9}>
                                                                                <TextField
                                                                                    className="adapter-txtsize"
                                                                                    placeholder="آدرس دقیق ارسال"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={3}
                                                                                    value={
                                                                                        bodycarShippingAddress || row.bodycarShippingAddress || ""
                                                                                    }
                                                                                    onChange={this.handlebodycarShippingAddress}
                                                                                    disabled={row["last_status"] !== "در حال بررسی"} // اگه تو row بود، غیرقابل تغییر
                                                                                />
                                                                            </Grid>
                                                                        )}




                                                                        {!row["last_status"] !== 'در حال بررسی' && (

                                                                        <Grid item xs={12} style={{ textAlign: "left", marginTop: 24 }}>
                                                                            <Button
                                                                                variant="contained"
                                                                                color="primary"
                                                                                size="large"
                                                                                onClick={() => this.handleChangeCheakbox2(this.state.request_id)}
                                                                                startIcon={<i className="fas fa-check-circle"></i>}
                                                                                style={{
                                                                                    borderRadius: "8px",
                                                                                    padding: "10px 24px",
                                                                                    fontSize: "12px",
                                                                                }}
                                                                            >
                                                                                ثبت نهایی
                                                                            </Button>
                                                                        </Grid>
                                                                        )}
                                                                    </Grid>
                                                                )}


                                                            </Paper>
                                                        </Container>

                                                    </TableContainer>

                                                )
                                            }

                                        })}




                                </Container>




                                <Container maxWidth="lg">

                                    <RequestSmsReceiver request_id={this.state['request_id']} />
                                </Container>





                            </Container>
                        </Grid>
                    </Grid>


                    {okstatus ? (
                        <Alert severity="success">
                            <AlertTitle>پیام</AlertTitle>
                            {errstr}
                        </Alert>
                    ) : null}
                </div>


            )
        }
    }
}


export default withStyles(styles)(MyMarketerRequests)
